import React from 'react';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../../../framework/bar-button/BarButtonFw';
import GridFw from '../../../../../framework/grid/GridFw';
import { BasePage } from '../../../../../framework/pages/BasePage';

export class ParametrosModal extends BasePage {
    
    
    createPageProperties = (pageApi) => {
        return {
            title: 'Visualización de Parámetros',
        };
    }
    
    renderPage(pageApi) {
        const getGridParametros = () => pageApi.getComponent('parametrosGrid');

        const barHeaderConfig = {
            fields:[
                {...BUTTON_DEFAULT.RETURN, onClick: () => pageApi.hideThisModal()}
            ]
        }

        const gridConfig = {
                rowId: 'id_rel_ss_muestras_cotizacion',
                showIndex: false,
                autoLoad: true,
                pagination: true,
                load: {
                    queryId: 311,
                    params: ()  =>{
                        return  { 
                            id_rel_ss_estacion: pageApi?.name?.data.id_rel_ss_estacion  || 0, 
                            id: pageApi?.name?.data.id_auto_grupo, 
                            grupo: pageApi?.name?.data.descripcion_grupo, 
                            id_doc_cotizacion : pageApi?.name?.data.id_doc_cotizacion,
                            id_matriz: pageApi?.name?.data.id_matriz
                        }
                    }
                },
                fields:[
                    {name: 'analisis', label:'Parámetro'},
                    {type:'select', name:'parametros', maxVisible: 2, label:'Sub Parámetros', labelName: 'parametrosDes', multiple:true, multipleInString: true,
                        load: {
                            queryId: 305,
                            params : () => {
                                return {id_rel_metodo_matriz: getGridParametros()?.itemEditing?.id_rel_metodo_matriz}
                            }
                        }, 
                    },
                ]
        };  
    
        return (
            <>
                <GridFw 
                    name="parametrosGrid" 
                    getParentApi={pageApi.getApi}
                    config={gridConfig}
                />
                <BarButtonFw 
                    name="agregarButton" 
                    getParentApi={pageApi.getApi}
                    config={barHeaderConfig}
                />
            </>
        )

    }
    
}
